import { GET_CLAIMANT_STATUSES } from "../../../enums/Request/request.types";

export const getClaimantStatusesAction = (data) => {
    return {
        type: GET_CLAIMANT_STATUSES,
        payload: data,
    };
};
